import {FC} from "react";
import {
    Alert24Regular,
    Beaker24Regular,
    BrainCircuit24Regular,
    CalendarClock24Regular,
    ClipboardTask24Regular,
    ClipboardCheckmark24Regular,
    DataTrending24Regular,
    DocumentText24Regular,
    Flash24Regular,
    Mail24Regular,
    Megaphone24Regular,
    PeopleTeam24Regular,
    PersonChat24Regular,
    Receipt24Regular,
    Settings24Regular
} from "@fluentui/react-icons";
import type {InsightActionKind} from "../insightCardModels";

export const KIND_ICONS: Record<InsightActionKind, FC<{className?: string}>> = {
    campaign: Megaphone24Regular,
    analysis: Beaker24Regular,
    automation: Flash24Regular,
    settings: Settings24Regular,
    report: DocumentText24Regular,
    cogs: DataTrending24Regular,
    ai_task: BrainCircuit24Regular,
    ops_task: ClipboardTask24Regular,
    alert: Alert24Regular,
    comms: Mail24Regular,
    pos: Receipt24Regular,
    schedule: CalendarClock24Regular,
    labor: PeopleTeam24Regular,
    coaching: PersonChat24Regular,
    checklist: ClipboardCheckmark24Regular
};
